export default __webpack_public_path__ + "static/media/nomeetingsfound.1eaa1bf2.svg";